module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/trouble-ecec0cea2e99fdb0969d2bb1932a5633.svg";